import initAboutServices from './about';
import initAuthServices from './auth';
import initConfigServices from './config';
import initCordovaServices from './cordova';
import initErrorServices from './error';
import initHeaderServices from './header';
import initHelpServices from './help';
import initLanguageServices from './language';
import initMobileNavigationServices from './mobileNavigation';
import initOfflineServices from './offline';
import initPlatformServices from './platform';
import initPreferencesServices from './preferences';
import initPreloginServices from './prelogin';
import initProductsServices from './products';
import initProfileMenuServices from './profileMenu';
import initRouterServices from './router';
import initSidebarServices from './sidebar';
import initStorageServices from './storage';
import initThemeServices from './theme';
import initTimezoneServices from './timezone';
import initTitleServices from './title';
import initUserStorageServices from './userStorage';
import initViewportServices from './viewport';

const initAppFrameServices = async () => {
  // error serivces is a basic service required by any other services
  initErrorServices();

  // must init cordova before use any axios request
  initCordovaServices();

  initOfflineServices();
  await initConfigServices();
  await initStorageServices();
  initPreloginServices();
  initAuthServices();
  await initUserStorageServices();
  initThemeServices();
  initPlatformServices();
  initTimezoneServices();
  initLanguageServices();
  initViewportServices();
  await initHelpServices();
  initAboutServices();
  initPreferencesServices();
  initHeaderServices();
  initTitleServices();
  initProfileMenuServices();
  initProductsServices();
  initSidebarServices();
  initMobileNavigationServices();
  initRouterServices();
};

export default initAppFrameServices;
